import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [{ paid: 400, debt: 70 }];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/payments.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
